import React, { Component } from "react";

export default class ErrorBoundary extends Component {

    componentDidCatch(error, errorInfo) {
        console.error(error);
        console.error(errorInfo);

        const isChunkLoadError =
            error?.name === 'ChunkLoadError' ||
            error?.message?.includes('Loading chunk') ||
            error?.message?.includes('__webpack_require__');

        if (isChunkLoadError) {
            const lastReload = sessionStorage.getItem('GD_CHUNK_ERROR_RELOAD');
            const now = Date.now();
            // 10초 내 중복 새로고침 방지 (무한루프 방지)
            if (!lastReload || now - Number(lastReload) > 10000) {
                sessionStorage.setItem('GD_CHUNK_ERROR_RELOAD', String(now));
                window.location.reload();
            }
        }
    }

    render() {
        return this.props.children;
    }
}